export var TIMESTAMP_REGISTRAR_KEY = '__RRTimestamps';
//# sourceMappingURL=constants.js.map